import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-manage-resume',
  templateUrl: './default-manage-resume.component.html',
  styleUrls: ['./default-manage-resume.component.scss']
})
export class DefaultManageResumeComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
